module.exports = {
	"header": "Claim ownership of listing",
	"claimRequestSuccess": "An e-mail with a link to claim the ownership of this listing has been sent.",
	"emailButton": "Claim your listing.",
	"emailAfterButton": "If you haven't requested a listing claim, simply ignore this e-mail.",
	"emailSubject": "Take ownership of your listing",
	"invalidToken": "Your claim token is either invalid or has expired.",
	"loginHeader": "Already have an account?",
	"paragraph1": "Either register or login to claim ownership of the listing and be able to modify the information about your business.",
	"registerHeader": "Create a new account.",
	"success": "You now have ownership of the seller account and listing."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/claim.json5
// module id = 1922
// module chunks = 6